import { Model } from '@vuex-orm/core'

export class FileParent extends Model {
  static entity = 'fileParent'
  static primaryKey = ['file_id', 'parent_id']

  static fields () {
    return {
      file_id: this.attr(null),
      parent_id: this.attr(null)
    }
  }
}

export default FileParent
